<template>

  <div class="bg-white rounded-sm px-2 pb-4 border shadow-sm">
    <div class="mt-3">
      <label class="block text-sm leading-5 ">SMS Body</label>
      <textarea name="more_info" type="email" v-model="sms" class="input" placeholder="Message description"></textarea>
    </div>

    <div class="mt-6 text-right">
      <button type="submit" v-on:click="saveRecord"
              class="py-2 px-4 uppercase bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
        Save
      </button>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";


export default {
  name: "UpdateSmsComponent",
  components: {},
  data() {
    return {
      sms: this.eDescription,
      errors: [],
    }
  },
  props: {
    breadcrumb: {type: Boolean, default: true},
    id: String
  },
  mounted() {
    GraphQl.sendRequest('{broadcast(id:"' + this.id + '"){sms}}')
        .then(response => {
          this.sms = response.broadcast.sms;
        })
  },
  methods: {
    saveRecord() {
      let query = {
        mutation: "updateBroadcastMessage",
        input: {
          id: this.id,
          sms: this.sms
        },
        output: "{code message recordId}"
      };
      GraphQl.sendRequest(query)
          .then(response => {
            this.$root.$emit(response.updateBroadcastMessage.code === 200 ? 'alert_success' : 'alert_error', [response.updateBroadcastMessage.message]);
          })
    }
  }
}
</script>

<style>
iframe {
  min-height: 700px !important;
}
</style>